var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.960103,
    y: 0.959996,
    width: 30.0799,
    height: 30.0799,
    rx: 15.0399,
    fill: "#EFF3FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.960103,
    y: 0.959996,
    width: 30.0799,
    height: 30.0799,
    rx: 15.0399,
    stroke: "#D7E1F4",
    strokeWidth: 1.91999
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5892 12.9878C18.5892 14.7175 17.4907 15.9805 16.1357 15.9805C14.7807 15.9805 13.6822 14.7175 13.6822 12.9878C13.6822 11.2581 14.7807 9.85596 16.1357 9.85596C17.4907 9.85596 18.5892 11.2581 18.5892 12.9878Z",
    stroke: "#4169E1",
    strokeWidth: 1.27999,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1362 18.486C11.3121 18.1653 11.6349 17.9681 11.9839 17.9681H20.0162C20.3653 17.9681 20.688 18.1653 20.8639 18.486L22.0089 20.5739C22.3905 21.2699 21.9186 22.1439 21.1612 22.1439H10.839C10.0815 22.1439 9.60961 21.2699 9.99126 20.5739L11.1362 18.486Z",
    stroke: "#4169E1",
    strokeWidth: 1.27999,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavprofile);
export default __webpack_public_path__ + "static/media/navprofile.c4d343486be14ba966bc7c7c8711b1cd.svg";
export { ForwardRef as ReactComponent };